module.exports = __webpack_public_path__ + "img/upcoming-fixtures-5.fbeb0c69.svg";